import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";
import Cookies from "js-cookie";
import {InputText} from "primereact/inputtext";
import moment from "moment";
import currencyFormatter from "currency-formatter";
import {addLocale, locale} from "primereact/api";

const SubscriptionplanListComponent = (props) => {
  const {t} = props;
  const [subscriptionplan, setSubscriptionplan] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(10);
  const dt = useRef(null);
  const filterTextMatchModes = [
    {label: t('filter_like'), value: 'like'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
  ]
  const filterNumberMatchModes = [
    {label: t('filter_between_number'), value: 'between'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
    {label: t('filter_greather_than'), value: '>'},
    {label: t('filter_greather_than_or_equals'), value: '>='},
    {label: t('filter_less_than'), value: '<'},
    {label: t('filter_less_than_or_equals'), value: '<='},
  ]
  const filterDateMatchModes = [
    {label: t('filter_between_date'), value: 'between'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
    {label: t('filter_greather_than'), value: '>'},
    {label: t('filter_greather_than_or_equals'), value: '>='},
    {label: t('filter_less_than'), value: '<'},
    {label: t('filter_less_than_or_equals'), value: '<='},
  ]
  const [lazyParams, setLazyParams] = useState({
    first: Number(localStorage.getItem('subscriptionplan_first')) || 0,
    rows: Number(localStorage.getItem('subscriptionplan_rows')) || rows,
    page: Number(localStorage.getItem('subscriptionplan_page')) || 0,
    sortField: localStorage.getItem('subscriptionplan_sortField') || 'id',
    sortOrder: Number(localStorage.getItem('subscriptionplan_sortOrder')) || -1,
    filters: JSON.parse(localStorage.getItem('subscriptionplan_filters')) || null,
  });
  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      window.App.setState({rerenderSubscriptionplanList: false})
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "system-admin/subscription-plan" + query,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setSubscriptionplan(response.data.data.items);
          setLoading(false);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: 10, value: 10},
        {label: 20, value: 20},
        {label: 50, value: 50},
        {label: 200, value: 200}
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', subscriptionplanSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    />
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', subscriptionplanSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-eye" className="p-button-sm  p-button-secondary"
                tooltip={t('show')}
                onClick={() => {
                  window.App.setState({
                    sidebarSubscriptionplanShow: true,
                    propsSubscriptionplan: {id: rowData.id}
                  })
                }}/>
        <Button icon="pi pi-pencil" className="p-button-sm  p-button-secondary p-ml-2"
                tooltip={t('edit')}
                onClick={() => {
                  window.App.setState({
                    sidebarSubscriptionplanForm: true,
                    propsSubscriptionplan: {id: rowData.id}
                  })
                }}/>
      </React.Fragment>
    );
  }

  addLocale('default', {
    clear: t('filter_clear'),
    apply: t('filter_apply'),
  });
  locale('default');

  useEffect(() => {
    if (lazyParams.filters) {
      document.getElementById('search').value = '';
      localStorage.setItem('subscriptionplan_filters', JSON.stringify(lazyParams.filters))
      if (lazyParams.sortField) {
        localStorage.setItem('subscriptionplan_sortField', lazyParams.sortField)
      }
      if (lazyParams.sortOrder) {
        localStorage.setItem('subscriptionplan_sortOrder', lazyParams.sortOrder)
      }
      if (lazyParams.first >= 0) {
        localStorage.setItem('subscriptionplan_first', lazyParams.first)
      }
      if (lazyParams.page >= 0) {
        localStorage.setItem('subscriptionplan_page', lazyParams.page)
      }
      if (lazyParams.rows) {
        localStorage.setItem('subscriptionplan_rows', lazyParams.rows)
        setRows(lazyParams.rows)
      }
    }
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderSubscriptionplanList === true])

  return (
    <>
      <div className={"p-grid"}>
        <div className={"p-col p-col-align-center"}>
          <h2 className={"p-m-0"}>{t('subscriptionplan_list')}</h2>
        </div>
        <div className={"p-col p-text-right p-col-align-center"}>
          {localStorage.getItem('subscriptionplan_filters') &&
            <a style={{color: "red"}} className={"p-button p-button-danger p-ml-2"}
               onClick={() => {
                 localStorage.removeItem('subscriptionplan_filters')
                 localStorage.removeItem('subscriptionplan_sortField')
                 localStorage.removeItem('subscriptionplan_sortOrder')
                 localStorage.removeItem('subscriptionplan_rows')
                 localStorage.removeItem('subscriptionplan_page')
                 localStorage.removeItem('subscriptionplan_first')
                 setLazyParams({
                   ...lazyParams,
                   filters: null
                 })
               }}
            >
              <i className={"pi pi-exclamation-triangle"}></i>&nbsp;{t('clear_filter')}
            </a>
          }
          <span className="p-input-icon-left p-ml-2">
              <i className="pi pi-search"/>
              <InputText id="search"
                         placeholder={t('search')}
                         onChange={(e) => {
                           clearTimeout(window.searchTimeout)
                           window.searchTimeout = setTimeout(function () {
                             localStorage.removeItem('subscriptionplan_filters')
                             localStorage.removeItem('subscriptionplan_sortField')
                             localStorage.removeItem('subscriptionplan_sortOrder')
                             localStorage.removeItem('subscriptionplan_rows')
                             localStorage.removeItem('subscriptionplan_page')
                             localStorage.removeItem('subscriptionplan_first')
                             setLazyParams({
                               ...lazyParams,
                               genericSearch: e.target.value,
                               filters: null
                             })
                           }, 1000)
                         }}
                         className={""}
              />
            </span>
        </div>
      </div>
      <DataTable
        ref={dt}
        size={"small"}
        emptyMessage={t('empty_message')}
        value={subscriptionplan} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
        onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
        onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
        paginatorTemplate={pager} rows={rows} emptyMessage={t('empty_message')}
        autoLayout={true}
        filterDisplay="menu"
        responsiveLayout={window.App.state.responsiveLayout}
        breakpoint="1365px"
        stripedRows
        dataKey="id"
        selectionMode={"single"}
        onRowDoubleClick={(rowData) => {
          if (!rowData.data.deleted_at_snapshot) {
            window.App.setState({
              sidebarSubscriptionplanShow: true,
              propsSubscriptionplan: {id: rowData.data.id}
            })
          }
        }}
      >
        
        <Column field="name" sortable header={t('name')}
                filter
                filterMatchMode="like"
                filterMatchModeOptions={filterTextMatchModes}
        ></Column>
        <Column field="code" sortable header={t('code')}
                filter
                filterMatchMode="like"
                filterMatchModeOptions={filterTextMatchModes}
        ></Column>
        <Column field="amount" sortable header={t('amount')}
                className={"p-py-0 p-text-nowrap p-text-right"}
                filter
                filterMatchMode="="
                filterMatchModeOptions={filterNumberMatchModes}
                body={(rowData) => {
                  return (
                    <span>
                      {currencyFormatter.format(
                        rowData.amount, {
                          precision: t('currency_precision'),
                          symbol: t('currency_symbol'),
                          decimal: t('currency_decimal'),
                          thousand: t('currency_thousand'),
                        }
                      )}
                    </span>
                  )
                }}
        ></Column>
        <Column field="paused_amount" sortable header={t('paused_amount')}
                className={"p-py-0 p-text-nowrap p-text-right"}
                filter
                filterMatchMode="="
                filterMatchModeOptions={filterNumberMatchModes}
                body={(rowData) => {
                  return (
                    <span>
                      {currencyFormatter.format(
                        rowData.paused_amount, {
                          precision: t('currency_precision'),
                          symbol: t('currency_symbol'),
                          decimal: t('currency_decimal'),
                          thousand: t('currency_thousand'),
                        }
                      )}
                    </span>
                  )
                }}
        ></Column>
        <Column field="currency" sortable header={t('currency')}
                filter
                filterMatchMode="like"
                filterMatchModeOptions={filterTextMatchModes}></Column>
        <Column field="frequency" sortable header={t('frequency')}
                filter
                filterMatchMode="like"
                filterMatchModeOptions={filterTextMatchModes}></Column>
        <Column field="visible_for_plan_list" sortable header={t('visible_for_plan_list')}
                body={(rowData) => {
                  return (
                    <span>{rowData.visible_for_plan_list ? t('yes') : t('no')}</span>
                  )
                }}
        ></Column>
        <Column field="created_at_snapshot" sortable header={t('created_at')}
                filter
                filterField={"created_at"}
                sortField={"created_at"}
                filterMatchMode="between"
                filterMatchModeOptions={filterDateMatchModes}
                body={(rowData) => {
                  if (rowData.created_at_snapshot !== null) {
                    return (
                      <span>{moment.utc(rowData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}</span>
                    )
                  }
                }}></Column>
        <Column field="updated_at_snapshot" sortable header={t('updated_at')}
                filterField={"updated_at"}
                sortField={"updated_at"}
                filter
                filterMatchMode="between"
                filterMatchModeOptions={filterDateMatchModes}
                body={(rowData) => {
                  if (rowData.updated_at_snapshot !== null) {
                    return (
                      <span>{moment.utc(rowData.updated_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}</span>
                    )
                  }
                }}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-nowrap p-text-right"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(SubscriptionplanListComponent);
